var map = {
	"./": 1387,
	"./Clutch": 2703,
	"./Clutch.js": 2703,
	"./NewUi": 2704,
	"./NewUi.js": 2704,
	"./OldUi": 2705,
	"./OldUi.js": 2705,
	"./index": 1387,
	"./index.js": 1387,
	"./style": 857,
	"./style.js": 857
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4247;